// The «Recogido» row's authorship caption, from the one bit the detail read carries
// (`collectedByUser`, delivered by CBX-11159 with BY-CONFIRMATION semantics).
//
// The copy NAMES THE MECHANISM (product decision 2026-08-20, replacing an earlier actor-naming
// pair). That is safe here for a reason worth stating: the «Acciones» card shows a
// «Recogida confirmada» banner after a write, so a caption reading
// «Autoconfirmado» on the row the agent just created would contradict it — except that a
// Customer-Care-forced transition creates no pickup, so it is UNATTRIBUTABLE, arrives `null`, and
// renders no line at all. The two statements can never appear together.
//
// **`manualmente` means the «Usuario»'s own session, not an agent's.** `true` is `Pickup.confirm`:
// somebody tapped confirm inside the «Usuario»'s app session. It is NOT «a colleague confirmed this
// by hand from the panel» — that case is the `null` above. Known ambiguity, accepted at the copy
// decision; if an agent ever reads it the other way, the fix is the wording, not this mapping.
//
// `false` is the scheduled auto-confirmation (`Pickup.auto_confirm`), which covers both the
// auto-confirm following a real opening the «Usuario» never confirmed and the branch that fires
// when nothing opened at all — «Autoconfirmado» is true of both.
//
// `null` returns `undefined`, never an em dash and never «desconocido»: the caller must be able to
// omit the slot. It is the DOMINANT value in production — an uncollected delivery, a collection that
// left no pickup, or any pickup predating the field's deploy, since the datum is forward-only with
// no backfill.
// TODO: i18n — copy en ES hasta Fase 1.
const CONFIRMED_BY_USER = 'Confirmado manualmente';
const AUTOCONFIRMED = 'Autoconfirmado';

export function collectionAuthorshipNote(collectedByUser: boolean | null): string | undefined {
  if (collectedByUser === null) return undefined;
  return collectedByUser ? CONFIRMED_BY_USER : AUTOCONFIRMED;
}
